import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import {
  Input,
  Password,
  Button,
  Check,
  Message,
} from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { urls as signinUrls } from '~/auth/signin/routes/urls';
import { SIGNUP_FORM } from '../constants';
import { isValidString } from '~/accounts/signup/forms/utils';

const classNamePrefix = 'Signup--Form';
const emailRegex = /^.+@.+\..+$/;

const validate = (values) => {
  const errors = {};

  if (!isValidString(values.email)) {
    errors.email = 'Please enter an email';
  } else if (!emailRegex.test(values.email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (!isValidString(values.password)) {
    errors.password = 'Please enter a password';
  }

  if (values.password && values.password.length <= 6) {
    errors.password = 'Password must be at least 6 characters long';
  }

  if (!isValidString(values.first_name)) {
    errors.first_name = 'Please enter your first name';
  }

  if (!isValidString(values.last_name)) {
    errors.last_name = 'Please enter your last name';
  }

  if (!isValidString(values.name)) {
    errors.name = 'Please enter your business name';
  }

  if (!values.terms) {
    errors.terms = 'Please accept the terms and conditions';
  }

  return errors;
};

const openTerms = (e) => {
  e.stopPropagation();
  window.open('/sellers/', '__blank');
};

const UserInformationForm = ({
  handleSubmit, error, disabled
}) => (
  <form className={classNamePrefix} onSubmit={handleSubmit} autoComplete="off">
    {
      error && (
        <Message
          color='danger'
          border={true}
          message={(
            <React.Fragment>
              <strong><h4>{error.title}</h4></strong>
              <p>{error.details}</p>
            </React.Fragment>
          )}
        />
      )
    }
    <Row gutter='md' className={`${classNamePrefix}__row`}>
      <Col xs={12} md={6}>
        <Field
          name='email'
          label='Enter your email*'
          placeholder='you@example.com'
          component={Input}
          autoFocus={true}
        />
      </Col>
      <Col xs={12} md={6}>
        <Field
          name='password'
          label='Create a password*'
          placeholder='Password'
          component={Password}
          meter={true}
          required={true}
        />
      </Col>
    </Row>
    <Row gutter='md' className={`${classNamePrefix}__row u-marginTop0`}>
      <Col xs={12} md={6}>
        <Row gutter='sm'>
          <Col xs={12} md={6}>
            <Field
              name='first_name'
              label='First Name*'
              placeholder='First Name'
              component={Input}
            />
          </Col>
          <Col xs={12} md={6}>
            <Field
              name='last_name'
              label='Last Name*'
              placeholder='Last name'
              component={Input}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={6}>
        <Field
          name='name'
          label='Business Name*'
          placeholder='The Purrrfect Business'
          component={Input}
        />
      </Col>
    </Row>
    <Row gutter='md' className={`${classNamePrefix}__terms`}>
      <Col>
        <Field
          name='terms'
          label={(
            <span>By signing up, I agree to the <a onClick={openTerms}>Terms of Service</a>*</span>
          )}
          component={Check}
          required={true}
        />
      </Col>
    </Row>
    <Row className={`${classNamePrefix}__buttons`} gutter='md' justify='edges'>
      <Col xs={12} md={6}>
        <h4>Already have an account? <a href={signinUrls.getLoginPage()}>Sign in</a></h4>
        <h4 className='u-marginTop10'>Signing up as a vet clinic? <a href='/accounts/signup/'>Sign up here</a></h4>
      </Col>
      <Col xs={12} md={6}>
        <Button
          color='primary'
          type="submit"
          full={true}
          disabled={disabled}
        >
          Create Account
        </Button>
      </Col>
    </Row>
  </form>
);

UserInformationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.any
};

export default reduxForm({
  form: SIGNUP_FORM,
  validate
})(UserInformationForm);
